import React, { useEffect, useState } from "react";
import "./style.scss";
import "../LandingPage/LandingPage.scss";
import thanklogo from "../../images/landing-page/thanklogo.svg";
import curvedesign from "../../images/landing-page/curvedesign.svg";
import Spinner from "../../images/loader.gif";
import thankdesign from "../../images/landing-page/thankdesign.png";
import mbthankdesign from "../../images/landing-page/mbthankdesign.png";
import useWindowDimensions from "../../useWindowDimensions";

const LandingThankyou = () => {
  const { width } = useWindowDimensions();
  const [isLoader, setIsLoader] = useState(true);
  useEffect(() => {
    document.querySelector(".px-0.MainNavBar.shadow-lg").style.display = "none";
    document.querySelector(".CyanBg.MainFooter").style.display = "none";
  }, []);
  const imageLoaded = (e) => {
    if (e.target.complete && e.target.naturalHeight != 0) {
      setIsLoader(false);
    }
  };
  return (
    <>
      <div
        className="loader_wrapper"
        style={{ display: isLoader ? "flex" : "none" }}
      >
        <img src={Spinner} alt="spinner" />
      </div>
      <div className="thankyousec">
        <div className="thankyou_wrapper">
          <div className="thankyou_content">
            <img
              src={width >= 768 ? thankdesign : mbthankdesign}
              alt="Thank design"
              className="thankdesign"
              onLoad={imageLoaded}
            />
            <img src={thanklogo} alt="Thank you logo" className="thanklogo" />
            <h1 className="thank_heading">We Are So Glad You Joined Us! </h1>
            <img src={curvedesign} alt="" className="thanklogo" />
            <p className="thankyoudesc">
              Thank you for being a part of our 50 years of legacy and for your{" "}
              <br />
              continued patronage! Visit every Wednesday 12th July onwards to
              know the winners.
            </p>
            <a href="/50-years-contest" className="thankbtn">
              GO back TO HOME
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingThankyou;
